const examRoutes = [
	{
		path: '/yuejuan',
		name: 'yuejuan',
		component: () => import('../home')
	}
]
export default examRoutes
